import gql from 'graphql-tag';

export default gql`
query getSiteOrderByItemStatus( 
    $stationValues: [String!]
    $station: String! 
    $status: [RESTAURANT_ORDER_STATUS!]!
    $skip: Int! 
    $limit: Int!
    ){
    getSiteOrderByItemStatus(
      stationValues: $stationValues
      station: $station 
      status: $status
      skip: $skip 
      limit: $limit
    ){
      id
      orderId
      noOfGuest
      counterId
      area
      # attachedArea
      parentOrderRef
      countryCode
      tokenId
      siteId
      name
      mobile
      date
      timestamp
      updatedAt
      tableNo
      orderFrom
      primaryWaiter
      preparationTime
      orderSource
      externalOrderId
      orderTags {
      tag_type
      content
      }
      subOrderFrom
      orderStatus
      orderList{
        subOrderId
        createdAt
        createdBy
        services{
          serviceId
          courseFiredAt
          serviceName
          courseId
          qty
          status
          pmInventory
          departmentId
          purchaseItemRef
          noDiscountItem
          costPrice
          tax
          taxType
          isUrgent
          addons{
           attachedAddonCat
           isCustomQty
            serviceName
            serviceRate
             qty
           }
          uId
          attachedCat
          instruction
          station
          kotId
          kotId
          inprocessAt
          kotgeneratedAt
          cancelledAt
          preparedAt
          completedAt
          refId
          hsnCode
        }
      }
    }
  }
  
`